import { priceDisplayFormat } from "aldoo-ra/CMSModels/StorePrice/display-formatters"
import { url } from "aldoo-ra/CMS/url"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import { XMarkIcon } from "@heroicons/react/24/outline"
import NumericStepper from "aldoo-ra/NumericStepper"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import Localization from "aldoo-ra/Localization"

/**
 * This is how we render a product in the Shopping Cart
 */
export default function Product({ product }) {
  const texts = TextBundle({ id: "aldoo-store" })
  const { template } = Localization()

  // Check if product has introductory pricing
  const priceModel = product.price_model?.find(pm => pm.primary)
  const phases = priceModel?.phases

  const introPhase = phases?.find(p => p.phase_type === 'introductory' && p.enabled !== false)
  const regularPhase = phases?.find(p => p.phase_type === 'regular' && p.enabled !== false)

  // Format interval for display (localized)
  const formatInterval = (phase) => {
    if (!phase) return ''
    const count = phase.interval_count || 1
    const interval = phase.interval || 'month'

    // Get localized interval from TextBundle
    const localizedInterval = texts?.[interval] || interval

    // For count > 1, append 's' for English pluralization
    // Note: Other languages handle pluralization differently
    return count === 1 ? localizedInterval : `${count} ${localizedInterval}s`
  }

  // Calculate intro duration
  const formatIntroDuration = (phase) => {
    if (!phase) return ''
    const iterations = phase.iterations || 1
    const count = phase.interval_count || 1
    const interval = phase.interval || 'month'
    const totalUnits = iterations * count
    return totalUnits === 1 ? `${totalUnits} ${interval}` : `${totalUnits} ${interval}s`
  }

  const hasIntroPrice = introPhase && regularPhase
  const displayPrice = hasIntroPrice ? introPhase.amount : product.amount
  const displayCurrency = hasIntroPrice ? introPhase.currency : product.currency

  return (
    <div className="relative flex items-start md:items-center justify-start bg-primary/5 rounded-[10px] gap-5 p-5">
      <img
        className="w-20 h-20 object-cover rounded-[5px] outline outline-primary shadow-lg outline-2"
        src={url(product.thumbnail)}
        alt={product.name}
      />

      {/* Product Name and Price */}
      <div className="w-full flex flex-col md:flex-row items-start md:items-center gap-2">
        <div className="flex flex-col">
          <Typography
            variant="body_20_accent"
            className="!text-[16px] lg:!text-[18px] xl:!text-[20px] text-text"
          >
            {product.name}
          </Typography>

          {/* Show renewal info if has intro pricing */}
          {hasIntroPrice && (
            <Typography
              variant="info_14"
              className="text-text_secondary/80 mt-1"
            >
              {template(texts?.product_introductory_renew || "Renews at {{price}} / {{duration}} after promo period", {
                price: priceDisplayFormat(regularPhase.amount, regularPhase.currency),
                duration: formatInterval(regularPhase)
              })}
            </Typography>
          )}
        </div>

        {/* Price */}
        <Typography
          variant="body_20_accent"
          className="!text-[16px] lg:!text-[18px] xl:!text-[20px] text-text my-0 md:ml-auto"
        >
          {priceDisplayFormat(displayPrice, displayCurrency)}
        </Typography>
      </div>

      {/* <NumericStepper
        variant="compact"
        readOnly
        styleOverrides={{
          buttonVariant: "secondary_s",
        }}
        min={1}
        max={10}
        value={product.quantity}
        onStep={(direction) => {
          direction > 0 ? product.add() : product.remove()
        }}
      /> */}
      
      {/* <Button
        className="absolute md:relative w-8 h-8 top-6 md:top-auto right-6 md:right-auto items-center rounded-full outline outline-primary hover:bg-white"
        variant=""
        onClick={() => product.clear()}
      >
        <XMarkIcon className="mx-auto w-5 h-5 text-primary" />
      </Button> */}
    </div>
  )
}
